/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import IcomoonReact from 'icomoon-react';
import IconButton from '@material-ui/core/IconButton';

import iconSet from '../../../../shared/images/teambuildr-selection.json';

const SendButton = ({ onClick, disabled }) => (
  <IconButton
    size='small'
    aria-label='send button'
    edge='end'
    onClick={onClick}
    disabled={disabled}
  >
    <IcomoonReact
      iconSet={iconSet}
      size={15}
      icon='send-alt'
      color={disabled ? '#9e9e9e' : '#444444'}
    />
  </IconButton>
);

SendButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default SendButton;
